import React from 'react';

import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import { PremiumScheduleSection } from '../index';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  setGeneratePremiumSchedule,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete
}) {
    return (
        <FormSection
          disableAll={disableAll}
          sectionName='PREMIUM_SCHEDULE'
          formikRef={formikRef}
          questionnaire={globalQuestionnaire}
          setQuestionnaire={setGlobalQuestionnaire}
          values={formikProps.values}
          error={formikProps.errors}
          setFieldValue={formikProps.setFieldValue}
          setFieldError={formikProps.setFieldError}
          idOperation={idOperation}
          idOperationParent={idOperationParent}
          onQuestionChange={(
            question,
            value,
            setFieldValue,
            questionnaireUpdated,
          ) =>
            PremiumScheduleSection.events.handleQuestionChange({
              question,
              value,
              questionnaireUpdated,
              setQuestionnaire: setGlobalQuestionnaire,
              setFieldValue,
              setGeneratePremiumSchedule,
              questionnaireAnswersToDelete,
              setQuestionnaireAnswersToDelete,
              documentsToDelete,
              setDocumentsToDelete
            })
          }
        />
    )
}

const components = {
  RenderSection
}

export { components }